import { LanguageEnum } from 'Component/pages/components/LanguageSelect/const';
import TemplateComponentsMyDetailComponent from './component';
import Udesk from 'Udesk';
import isNil from 'lodash/isNil';

class TemplateComponentsMyDetailRoute extends TemplateComponentsMyDetailComponent {
    asyncModel({ isReload } = {}) {
        this.privates.spinLoading = true;
        this.actions.update();
        let { sdkOptions, match } = this.props;
        let { lang } = this.privates;
        // let myDetailPromise = new Promise((resolve, reject) => {
        //     resolve({});
        // });

        const data = {
            lang,
        };
        // 这里，区分是否包含‘所有语言’类型的数据
        const data2 = {
            langList: !isNil(lang)
                ? lang === LanguageEnum.All
                    ? [lang]
                    : [LanguageEnum.All, lang]
                : undefined,
        };

        let taskUrl = Udesk.business.apiPath.concatApiPath(`inspectionTasks/list/base`, sdkOptions);
        let taskPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(taskUrl, data).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });
        let tagUrl = Udesk.business.apiPath.concatApiPath(`semantic-tag/list/base`, sdkOptions);
        let tagPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(tagUrl, data).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });
        let interUrl = Udesk.business.apiPath.concatApiPath(
            `interactiveCategories/list/base`,
            sdkOptions
        );
        let interPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(interUrl).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });
        let conceptUrl = Udesk.business.apiPath.concatApiPath(`conceptWords/list/base`, sdkOptions);
        let conceptPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(conceptUrl, data).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });
        // let infoUrl = Udesk.business.apiPath.concatApiPath(`information-entity/list/base?systemType=${Udesk.data.init.company.systemType}`, sdkOptions);
        const queryString = $.param(data2, true);
        let infoUrl = Udesk.business.apiPath.concatApiPath(
            `information-entity/list/base?${queryString}`,
            sdkOptions
        );
        let infoPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(infoUrl).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });
        let multiUrl = Udesk.business.apiPath.concatApiPath(
            `interactiveDatas/list/base`,
            sdkOptions
        );
        let multiPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(multiUrl).then(
                (resp) => {
                    resolve(resp);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });
        Promise.all([
            taskPromise,
            tagPromise,
            interPromise,
            conceptPromise,
            infoPromise,
            multiPromise,
        ])
            .then(() => {
                if (match.params.id && !isReload) {
                    this.actions.geDetail();
                } else {
                    this.privates.spinLoading = false;
                    this.actions.update();
                }
            })
            .catch(() => {
                this.privates.spinLoading = false;
                this.actions.update();
            });
        return {
            taskData: taskPromise,
            tagData: tagPromise,
            interData: interPromise,
            conceptData: conceptPromise,
            infoData: infoPromise,
            multiData: multiPromise,
            // myDetailData: myDetailPromise,
        };
    }
    parseAsyncModel(asyncModel, { asyncKey }) {
        return asyncModel;
    }
}

export default TemplateComponentsMyDetailRoute;
